
<template>
  <div class="cooperation-center">
    <!-- 顶部导航 -->
    <van-nav-bar
      :title="$t('cooperation.center')"
      fixed
      left-arrow
      placeholder
      @click-left="$router.back()"
    />

    <!-- 主内容区 -->
    <div class="main-content">
      <!-- 合作申请中心 -->
      <section class="section">
        <h2 class="section-title">
          {{ $t('cooperation.applicationCenter') }}
        </h2>
        <div class="cooperation-cards">
          <van-card
            v-for="card in cooperationCards"
            :key="card.type"
            class="cooperation-card"
            :class="card.type"
          >
            <template #title>
              <div class="card-header">
                <div
                  class="card-icon"
                  :class="card?.type"
                >
                  <img :src="require('../../assets/cooperation/' + card?.icon)">
                </div>
                <div class="card-title">
                  <h3>{{ $t(`cooperation.${card.type}.title`) }}</h3>
                  <p>{{ $t(`cooperation.${card.type}.subtitle`) }}</p>
                </div>
              </div>
            </template>
            <template #desc>
              <p class="card-desc">
                {{ $t(`cooperation.${card.type}.description`) }}
              </p>
              <ul class="benefits">
                <li
                  v-for="(benefit, index) in card.benefits"
                  :key="index"
                >
                  {{ $t(`cooperation.benefits.${card.type}[${index}]`) }}
                </li>
              </ul>
            </template>
            <template #footer>
              <van-button
                round
                block
                class="apply-btn"
                :class="card.type"
                @click="handleApply(card)"
              >
                {{ $t('common.applyNow') }}
              </van-button>
            </template>
          </van-card>
        </div>
      </section>

      <!-- 合作百货店展示 -->
      <section class="section">
        <h2 class="section-title">
          {{ $t('cooperation.departmentStores') }}
        </h2>
        <div
          v-if="departmentStores && departmentStores.length > 0"
          class="department-stores"
        >
          <van-card
            v-for="store in departmentStores"
            :key="store.id"
            class="store-card"
          >
            <!--            <template #thumb>-->
            <!--              <div-->
            <!--                class="store-image"-->
            <!--                :style="{ backgroundColor: store.color }"-->
            <!--              />-->
            <!--            </template>-->
            <template #title>
              <h3 class="store-name">
                {{ store?.storeName }}
              </h3>
            </template>
            <template #desc>
              <div class="store-location">
                <van-icon name="location" />
                <!--                {{ $t(`stores.${store.key}.location`) }}-->
                {{ store?.address }}
              </div>
              <div class="store-location">
                {{ store?.groupName }}
              </div>
              <div class="store-tags">
                <van-tag
                  class="store-tag"
                  type="primary"
                  size="medium"
                >
                  {{ store?.country }}
                </van-tag>
                <van-tag
                  class="store-tag"
                  type="success"
                  size="medium"
                >
                  {{ store?.storeLevel }}
                </van-tag>
              </div>
            </template>
            <!--            <template #footer>-->
            <!--              <div class="store-actions">-->
            <!--                <van-button-->
            <!--                  size="small"-->
            <!--                  class="preview-btn"-->
            <!--                  @click="handlePreview(store)"-->
            <!--                >-->
            <!--                  {{ $t('common.preview') }}-->
            <!--                </van-button>-->
            <!--                <van-button-->
            <!--                  size="small"-->
            <!--                  type="primary"-->
            <!--                  class="brands-btn"-->
            <!--                  @click="handleBrands(store)"-->
            <!--                >-->
            <!--                  {{ $t('common.brandGuide') }}-->
            <!--                </van-button>-->
            <!--              </div>-->
            <!--            </template>-->
          </van-card>
        </div>

        <div
          v-else
          class="empty-state"
        >
          <van-empty
            image="search"
            :description="$t('cooperation.noStores')"
          >
            <van-button
              round
              type="primary"
              class="empty-action-btn"
              @click="handleApply(cooperationCards[0])"
            >
              {{ $t('cooperation.applyFirstStore') }}
            </van-button>
          </van-empty>
        </div>
      </section>
    </div>

    <!-- 品牌预览模态框 -->
    <van-popup
      v-model:show="showPreview"
      position="bottom"
      round
      :style="{ height: '80%' }"
    >
      <div class="preview-modal">
        <div class="modal-header">
          <h2 class="modal-title">
            {{ previewStore ? previewStore.storeName : '' }}
          </h2>
          <van-icon
            name="cross"
            @click="showPreview = false"
          />
        </div>
        <div class="modal-content">
          <van-tabs
            v-model:active="activeTabPreview"
            sticky
          >
            <van-tab :title="$t('preview.story')">
              <div class="tab-content">
                <h4>{{ $t('preview.origin') }}</h4>
                <p>{{ $t('preview.originContent') }}</p>
                <h4>{{ $t('preview.designConcept') }}</h4>
                <p>{{ $t('preview.designConceptContent') }}</p>
              </div>
            </van-tab>
            <van-tab :title="$t('preview.designer')">
              <div class="tab-content">
                <div class="designer-profile">
                  <div class="designer-avatar" />
                  <div class="designer-details">
                    <h4>林悦</h4>
                    <p>{{ $t('preview.designerTitle') }}</p>
                    <p>{{ $t('preview.designerDesc') }}</p>
                    <div class="social-links">
                      <van-icon
                        name="wechat"
                        class="social-icon"
                      />
                      <van-icon
                        name="weibo"
                        class="social-icon"
                      />
                      <van-icon
                        name="photo"
                        class="social-icon"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab :title="$t('preview.products')">
              <div class="tab-content">
                <h4>{{ $t('preview.collection') }}</h4>
                <p>{{ $t('preview.collectionDesc') }}</p>
                <div class="product-grid">
                  <div
                    v-for="product in products"
                    :key="product"
                    class="product-item"
                  >
                    {{ product }}
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab :title="$t('preview.events')">
              <div class="tab-content">
                <div
                  v-for="event in events"
                  :key="event.id"
                  class="event-card"
                >
                  <h5>{{ event.title }}</h5>
                  <p>{{ event.time }}</p>
                  <p>{{ event.location }}</p>
                  <van-button
                    type="primary"
                    size="small"
                  >
                    {{ $t('common.signUp') }}
                  </van-button>
                </div>
              </div>
            </van-tab>
          </van-tabs>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { ref, reactive, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { showToast } from 'vant'
import { queryDepartmentStoreList } from '@/api/cooperation'
export default {
  name: 'CooperationCenter',
  setup () {
    const router = useRouter()
    const { locale, t } = useI18n()

    // 响应式数据
    // const activeTab = ref('cooperation')
    const showPreview = ref(false)
    const activeTabPreview = ref(0)
    const previewStore = ref(null)
    const currentLocale = ref('zh')

    // 合作卡片数据
    const cooperationCards = reactive([
      {
        type: 'department',
        icon: 'shop.png',
        title: t('cooperation.department.title'),
        subtitle: t('cooperation.department.subtitle'),
        benefits: [0, 1, 2, 3],
        path: '/cooperation/departmentStore'
      },
      {
        type: 'brand',
        icon: 'certificate.png',
        benefits: [0, 1, 2, 3],
        path: '/cooperation/brandApplication'
      },
      {
        type: 'designer',
        icon: 'brush.png',
        benefits: [0, 1, 2, 3],
        path: '/cooperation/designerApplication'
      },
      {
        type: 'officer',
        icon: 'user-circle.png',
        benefits: [0, 1, 2, 3],
        path: '/cooperation/officerApplication'
      }
    ])

    // 百货店数据
    // const departmentStores = reactive([
    //   {
    //     id: 1,
    //     key: 'beijingSKP',
    //     color: '#a5d6a7',
    //     tags: [0, 1, 2]
    //   },
    //   {
    //     id: 2,
    //     key: 'shanghaiIFC',
    //     color: '#90caf9',
    //     tags: [0, 1]
    //   },
    //   {
    //     id: 3,
    //     key: 'shenzhenMixC',
    //     color: '#ffe082',
    //     tags: [0, 1, 2]
    //   },
    //   {
    //     id: 4,
    //     key: 'chengduTaikooli',
    //     color: '#f48fb1',
    //     tags: [0, 1, 2]
    //   }
    // ])
    const departmentStores = ref([])

    function getDepartmentStoreList () {
      const params = {
        page: 1,
        size: 12
      }
      queryDepartmentStoreList(params).then(res => {
        departmentStores.value = res.list
      }).catch(error => {
        showToast(error.msg)
      })
    }

    // 产品数据
    const products = reactive(['连衣裙', '西装外套', '针织衫', '半身裙'])

    // 活动数据
    const events = reactive([
      {
        id: 1,
        title: '上海时装周2023秋冬发布会',
        time: '2023年10月15日 19:00',
        location: '上海西岸艺术中心'
      },
      {
        id: 2,
        title: '秋季订货会',
        time: '2023年9月20-22日',
        location: '北京展览馆'
      }
    ])

    const handleApply = (applyCard) => {
      router.push(applyCard.path)
      // if (type === 'officer') {
      //   router.push('/application/officer')
      // } else {
      //   showToast(t('common.applyNow'))
      // }
    }

    const handlePreview = (store) => {
      previewStore.value = store
      showPreview.value = true
    }

    const handleBrands = (store) => {
      showToast(`${t('common.brandGuide')}: ${t(`stores.${store.key}.name`)}`)
    }

    const switchLanguage = (lang) => {
      locale.value = lang
      currentLocale.value = lang
    }

    onMounted(() => {
      getDepartmentStoreList()
    })
    return {
      // activeTab,
      showPreview,
      activeTabPreview,
      previewStore,
      currentLocale,
      cooperationCards,
      departmentStores,
      products,
      events,
      handleApply,
      handlePreview,
      handleBrands
    }
  }
}
</script>

<style lang="scss" scoped>
.cooperation-center {
  min-height: 100vh;
  background-color: #f7f8fa;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

.language-switcher {
  display: flex;
  justify-content: flex-end;
  padding: 10px 16px;
  gap: 8px;

  @media (min-width: 768px) {
    padding: 10px 24px;
  }
}

.main-content {
  padding: 16px;

  @media (min-width: 768px) {
    max-width: 1200px;
    margin: 0 auto;
    padding: 24px;
  }
}

.section {
  margin-bottom: 40px;

  &-title {
    font-size: 20px;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 20px;
    position: relative;
    padding-left: 12px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 20px;
      background: #3b82f6;
      border-radius: 2px;
    }
  }
}

// 合作卡片样式
.cooperation-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
}

.cooperation-card {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border-top: 5px solid;
  margin-bottom: 0;

  &.department {
    border-top-color: #10b981;
  }

  &.brand {
    border-top-color: #f59e0b;
  }

  &.designer {
    border-top-color: #8b5cf6;
  }

  &.officer {
    border-top-color: #ef4444;
  }

  :deep(.van-card__header) {
    padding: 20px 20px 0;
  }

  .card-header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    .card-icon {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      color: white;
      margin-right: 12px;

      img{
        width: 25px;
        height: 25px;
      }

      &.department {
        background: #10b981;
      }

      &.brand {
        background: #f59e0b;
      }

      &.designer {
        background: #8b5cf6;
      }

      &.officer {
        background: #ef4444;
      }
    }

    .card-title {
      h3 {
        font-size: 18px;
        font-weight: 600;
        color: #1e293b;
        margin: 0 0 4px;
      }

      p {
        font-size: 14px;
        color: #64748b;
        margin: 0;
      }
    }
  }

  .card-desc {
    font-size: 14px;
    color: #64748b;
    margin-bottom: 16px;
    line-height: 1.5;
  }

  .benefits {
    list-style: none;
    padding: 0;
    margin: 0 0 20px;

    li {
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #475569;

      &::before {
        content: "✓";
        font-weight: bold;
        margin-right: 8px;
        font-size: 16px;
      }

      .department &::before {
        color: #10b981;
      }

      .brand &::before {
        color: #f59e0b;
      }

      .designer &::before {
        color: #8b5cf6;
      }

      .officer &::before {
        color: #ef4444;
      }
    }
  }

  :deep(.van-card__footer) {
    padding: 0 20px 20px;
  }

  .apply-btn {
    height: 44px;
    font-size: 16px;
    font-weight: 500;
    border: none;

    &.department {
      background: #10b981;

      &:active {
        background: #0d9c6d;
      }
    }

    &.brand {
      background: #f59e0b;

      &:active {
        background: #d97706;
      }
    }

    &.designer {
      background: #8b5cf6;

      &:active {
        background: #7c3aed;
      }
    }

    &.officer {
      background: #ef4444;

      &:active {
        background: #dc2626;
      }
    }
  }
}

// 百货店样式
.department-stores {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
}

// 空状态样式
.empty-state {
  background: white;
  border-radius: 16px;
  padding: 40px 20px;
  text-align: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

  :deep(.van-empty) {
    padding: 20px 0;

    .van-empty__image {
      width: 120px;
      height: 120px;
      margin-bottom: 16px;
    }

    .van-empty__description {
      font-size: 16px;
      color: #64748b;
      margin-bottom: 24px;
    }
  }

  .empty-action-btn {
    height: 44px;
    font-size: 16px;
    font-weight: 500;
    background: #10b981;
    border: none;
    padding: 0 32px;

    &:active {
      background: #0d9c6d;
    }
  }
}

.store-card {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 0;

  :deep(.van-card__thumb) {
    width: 100%;
    height: 160px;
  }

  .store-image {
    width: 100%;
    height: 100%;
  }

  :deep(.van-card__content) {
    padding: 16px;
  }

  .store-name {
    font-size: 18px;
    font-weight: 600;
    color: #1e293b;
    margin: 0 0 8px;
  }

  .store-location {
    display: flex;
    //align-items: center;
    font-size: 14px;
    color: #64748b;
    margin-bottom: 12px;
    text-align: left;

    .van-icon {
      margin-right: 4px;
    }
  }

  .store-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 16px;
  }

  .store-tag {
    background: #e3f2fd;
    color: #1a2a6c;
    border: none;
  }

  :deep(.van-card__footer) {
    padding: 0 16px 16px;
  }

  .store-actions {
    display: flex;
    gap: 12px;

    .preview-btn,
    .brands-btn {
      flex: 1;
      height: 36px;
    }

    .preview-btn {
      background: #f1f5f9;
      color: #475569;
      border: none;
    }
  }
}

// 预览模态框样式
.preview-modal {
  height: 100%;
  display: flex;
  flex-direction: column;

  .modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    border-bottom: 1px solid #e2e8f0;

    .modal-title {
      font-size: 18px;
      font-weight: 600;
      color: #1e293b;
      margin: 0;
    }

    .van-icon {
      font-size: 20px;
      color: #64748b;
    }
  }

  .modal-content {
    flex: 1;
    overflow: hidden;

    :deep(.van-tabs) {
      height: 100%;
      display: flex;
      flex-direction: column;

      .van-tabs__content {
        flex: 1;
        overflow-y: auto;
      }
    }
  }

  .tab-content {
    padding: 20px;

    h4 {
      font-size: 16px;
      font-weight: 600;
      color: #1e293b;
      margin: 0 0 12px;
    }

    p {
      font-size: 14px;
      color: #64748b;
      line-height: 1.6;
      margin-bottom: 20px;
    }
  }

  .designer-profile {
    display: flex;
    margin-bottom: 20px;

    .designer-avatar {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      background: #e2e8f0;
      margin-right: 16px;
    }

    .designer-details {
      flex: 1;

      h4 {
        margin: 0 0 4px;
      }

      p {
        margin: 0 0 8px;
        font-size: 14px;
        color: #64748b;
      }
    }

    .social-links {
      display: flex;
      gap: 12px;
      margin-top: 12px;

      .social-icon {
        font-size: 20px;
        color: #64748b;
      }
    }
  }

  .product-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    margin-top: 16px;

    .product-item {
      height: 120px;
      background: #f8fafc;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #475569;
    }
  }

  .event-card {
    background: #f8fafc;
    padding: 16px;
    border-radius: 8px;
    margin-bottom: 16px;

    h5 {
      font-size: 16px;
      font-weight: 600;
      color: #1e293b;
      margin: 0 0 8px;
    }

    p {
      font-size: 14px;
      color: #64748b;
      margin: 0 0 8px;
    }

    .van-button {
      margin-top: 8px;
    }
  }
}

// 响应式设计
@media (min-width: 768px) {
  .section-title {
    font-size: 24px;
  }

  .cooperation-cards {
    gap: 24px;
  }

  .department-stores {
    gap: 24px;
  }

  .cooperation-card {
    .card-header {
      .card-icon {
        width: 60px;
        height: 60px;
        font-size: 28px;
        img{
          width: 30px;
          height: 30px;
        }
      }
    }
  }
  // PC端空状态优化
  .empty-state {
    padding: 80px 40px;

    :deep(.van-empty) {
      .van-empty__image {
        width: 160px;
        height: 160px;
      }

      .van-empty__description {
        font-size: 18px;
      }
    }

    .empty-action-btn {
      height: 48px;
      font-size: 18px;
      padding: 0 40px;
    }
  }
}
</style>
